jQuery(document).ready(function ($) {
    // responsive tables
    $('.content table').each(function () {
        if (!$(this).parents('.search-results').length) {
            if (!$(this).hasClass('tablesaw')) {
                $(this).addClass('tablesaw').attr('data-tablesaw-mode', 'stack');
            }
        }
    });

    $('.blog-search-dd, .categories-search-dd').on('change', function () {
        window.location = this.value;
    });

    var postImage = $('.two-column.blog .main-content img');
    if (postImage.length > 0) {
        postImage[0].style = 'display: none;';
        $('.two-column.blog .post-details .post-image img').attr('src', postImage[0].src);
    }
    var featuredImage = $('.post-details .post-featured-image');    
    if (featuredImage.text()) {      
        featuredImage.hide();
        $('.two-column.blog .post-details .post-image img').attr('src', featuredImage.text());
    } 
    var messageOpen = localStorage.getItem('message-open');

    if (messageOpen & messageOpen == "closed") {gulp
        $('.opening-message').removeClass('open');
    }

    $('.opening-message .fa-plus').on('click', function () {
        $('.opening-message').addClass('open');
        localStorage.setItem('message-open', 'open');
    });

    $('.opening-message .fa-close').on('click', function () {
        $('.opening-message').removeClass('open');
        localStorage.setItem('message-open', 'closed');
    });

    var shareButtons = [
        { id: 'facebook', url: 'https://www.facebook.com/sharer/sharer.php?u=' + getPageURLForShare() },
        { id: 'twitter', url: 'https://twitter.com/intent/tweet?text=&url=' + getPageURLForShare() },
        {
            id: 'linkedin', url: 'https://www.linkedin.com/shareArticle?mini=true&url=' + getPageURLForShare() + '&' +
                'title=Christian Retreats Network Blog Post&summary=&source='
        }
    ];

    function getPageURLForShare() {
        return window.location.href;
    }

    $('.share-links .fa-facebook').attr('href', shareButtons[0].url);
    $('.share-links .fa-twitter').attr('href', shareButtons[1].url);
    $('.share-links .fa-linkedin-in').attr('href', shareButtons[2].url);

    if ($('input.search-submit').length > 0) {
        $('input.search-submit').attr('value', '');
    }
});
/*! Tablesaw - v3.0.3 - 2017-07-13
* https://github.com/filamentgroup/tablesaw
* Copyright (c) 2017 Filament Group; Licensed MIT */
(function (win) {
    "use strict";
    var $;
    if ("shoestring" in win) {
        $ = win.shoestring;
    } else if ("jQuery" in win) {
        $ = win.jQuery;
    } else {
        throw new Error("tablesaw: DOM library not found.");
    }

    // DOM-ready auto-init of plugins.
    // Many plugins bind to an "enhance" event to init themselves on dom ready, or when new markup is inserted into the DOM
    // Use raw DOMContentLoaded instead of shoestring (may have issues in Android 2.3, exhibited by stack table)
    if ("addEventListener" in document) {
        document.addEventListener("DOMContentLoaded", function () {
            $(document).trigger("enhance.tablesaw");
        });
    }
})(typeof window !== "undefined" ? window : this);
